// Singleton pattern
if (!global._config) {
  var config = require('config');
  global._config = config;

  // Try and get the application name from the app's package.json file.
  try {
    // Set to the config object for access
    config.appName = require(process.cwd() + '/package.json').name;
  } catch (error) {
    // No package.json found so fail silently and set default
    config.appName = 'default';
  }
}

module.exports = global._config;

